import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/mg-foundation-api/admin/login',
    method: 'post',
    data,
  })
}

export function getUserInfo() {
  return request({
    url: '/mg-foundation-api/cmsPlatformUser/detail',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/mg-foundation-api/admin/logout',
    method: 'post',
  })
}

export function register() {
  return request({
    url: '/register',
    method: 'post',
  })
}

// 修改密码
export function putChangePassWord(data) {
  return request({
    url: '/mg-foundation-api/cmsPlatformUser/changePassword',
    method: 'put',
    data: data,
  })
}

/**
 * 获取员工经营组织相关信息
 * 1.默认采购仓库
 * @param {*} data
 * @returns
 */
export function getEmployeeBusinessGroupInfo(data) {
  return request({
    url: '/mg/daohang-basic-api/employeeBusinessGroup/list',
    method: 'post',
    data,
  })
}
